export const formatDateTime = (dateTimeString) => {
  const dateTime = new Date(dateTimeString);

  const time = dateTime.toTimeString().split(" ")[0].slice(0, 5);
  const date = dateTime.toLocaleDateString("pt-BR");

  return { time, date };
};
